/**
 * Type de proposal habillé par un template de site web.
 *
 * Choisi **à la création** et figé ensuite : il décide du catalogue de
 * variables (opportunité ou offre, jamais les deux), et les variables déjà
 * posées dans le template deviendraient orphelines si on en changeait.
 * Mêmes valeurs que `Proposals::Template#templatable`.
 */

export const TEMPLATABLE_DEFAULT = 'opportunity';

export const TEMPLATABLE_OPTIONS = [
  { value: 'opportunity', label: 'Opportunité' },
  { value: 'offer', label: 'Offre' },
];

export function templatableLabel(value) {
  return TEMPLATABLE_OPTIONS.find((option) => option.value === value)?.label
    || TEMPLATABLE_OPTIONS[0].label;
}
